<template>
  <div
    @dblclick="$emit('dblClickEmptyArea')"
    id="gantt_test"
    ref="gantt"
    :class="this.colorClass"
    class="w-100"
  />
</template>

<script>
import "@/libs/dhtmlx-gantt/codebase/dhtmlxgantt";
// import '@/libs/dhtmlx-gantt/codebase/ext/dhtmlxgantt_smart_rendering'
// import {gantt} from 'dhtmlx-gantt';
import moment from "moment";
import { mapState, mapMutations } from "vuex";
import { debounce, memoize } from "lodash";
const events = [];
const gantt = Gantt.getGanttInstance();
export default {
  name: "Gantt",
  props: {
    ganttView: {
      type: String,
      default: "day"
    },
    ganttDay: {
      type: String,
      default: "full-week"
    },
    ganttComment: {
      type: String,
      default: "task-title"
    },
    ganttZoom: {
      type: String,
      default: "few"
    },
    colorClass: {
      type: String,
      default: ""
    },

    showAssignedTo: {
      type: Boolean,
      default: false
    },
    showBilling: {
      type: Boolean,
      default: false
    },
    currency: {
      type: Object,
      default: { value: "AUD", label: "Australia", symbol: "$" }
    },
    tasks: {
      type: Object,
      default() {
        return { data: [], links: [] };
      }
    }
  },
  data() {
    return {
      commentMode: "task-title"
    };
  },

  watch: {
    tasks(val) {
      this.initGantt();
    },
    ganttRender(val) {
      this.initGantt();
    },
    showBilling() {
      this.initGantt();
    },
    currency() {
      gantt.render();
    },
    ganttView() {
      this.initGantt();
    },
    ganttDay() {
      this.initGantt();
    },
    ganttComment(val) {
      this.commentMode = val;
      this.initGantt();
    },
    ganttZoom() {
      this.initGantt();
    }
  },

  methods: {
    ...mapMutations(["setLoading"]),

    onAssignedToUserIconClicked(id, userId, event) {
      this.$emit("assigned-to-user-clicked", id, userId);
    },

    initGantt() {
      this.setLoading(true);
      this.resetGantt();

      gantt.plugins({
        multiselect: true,
        tooltip: true
      });

      this.initNormalGantt();

      events.push(
        gantt.attachEvent("onGridResize", function(old_width, new_width) {
          gantt.config.show_grid = false;
          gantt.render();
        })
      );

      events.push(
        gantt.attachEvent("onTaskSelected", id => {
          let task = gantt.getTask(id);
          this.$emit("task-selected", task);
        })
      );

      events.push(
        gantt.attachEvent("onAfterTaskAdd", (id, task) => {
          this.$emit("task-updated", id, "inserted", task);
          task.progress = task.progress || 0;
          if (gantt.getSelectedId() == id) {
            this.$emit("task-selected", task);
          }
        })
      );

      gantt.attachEvent("onAfterTaskUpdate", (id, task) => {
        this.$emit("task-updated", id, "updated", task);
      });

      events.push(
        gantt.attachEvent("onAfterTaskDelete", id => {
          this.$emit("task-updated", id, "deleted");
          if (!gantt.getSelectedId()) {
            this.$emit("task-selected", null);
          }
        })
      );

      events.push(
        gantt.attachEvent("onAfterLinkAdd", (id, link) => {
          this.$emit("link-updated", id, "inserted", link);
        })
      );

      gantt.attachEvent("onAfterLinkUpdate", (id, link) => {
        this.$emit("link-updated", id, "updated", link);
      });

      events.push(
        gantt.attachEvent("onAfterLinkDelete", (id, link) => {
          this.$emit("link-updated", id, "deleted");
        })
      );

      // events.push(
      //   gantt.attachEvent("onMouseMove", function(e, f){
      //       // your code here
      //       console.log('over ', e, f)
      //   })
      // )

      events.push(
        gantt.attachEvent("onBeforeTaskDrag", (t, mode, e) => {
          //donot allow project to resize, only drag.
          let task = gantt.getTask(t);
          if (task.module.toUpperCase() == "PROJECT" && mode == "resize") {
            return false;
          }
          return true;
        })
      );

      events.push(
        gantt.attachEvent("onAfterTaskDrag", (id, mode, e) => {
          // alert('dragged')
          //   debounce((id, mode, e) => {
          //   //console.log("dragged", id, mode, e);
          //   this.$emit("task-dragged", id, e);
          //   return true;
          // }, 1000)
          let task = gantt.getTask(id);

          this.$emit("task-dragged", id, task);
        })
      );

      events.push(
        gantt.attachEvent("onTaskDblClick", (id, event) => {
          let task = gantt.getTask(id);
          this.$emit("task-dbl-click", id, event, task);
          return true;
        })
      );

      events.push(
        gantt.attachEvent("onTaskClick", (id, event) => {
          if (id) {
            let task = gantt.getTask(id);
            if (event.target.classList.contains("taskLink")) {
              this.$emit("task-link-clicked", id, task);
              console.log("link clicked ");
            } else if (event.target.classList.contains("avatar-assigned-by")) {
              let userID = event.target.getAttribute("data-user");
              this.$emit("assigned-by-user-clicked", id, userID, task);
            } else if (
              event.target.parentElement.classList.contains(
                "avatar-assigned-by"
              )
            ) {
              let userID = event.target.parentElement.getAttribute("data-user");
              this.$emit("assigned-by-user-clicked", id, userID, task);
            } else if (event.target.classList.contains("avatar-assigned-to")) {
              let userID = event.target.getAttribute("data-user");
              this.$emit("assigned-to-user-clicked", id, userID, task);
            } else if (
              event.target.parentElement.classList.contains(
                "avatar-assigned-to"
              )
            ) {
              let userID = event.target.parentElement.getAttribute("data-user");
              this.$emit("assigned-to-user-clicked", id, userID, task);
            }
          }
          return true;
        })
      );

      let self = this;
      events.push(
        gantt.attachEvent("onGanttRender", (id, event) => {
          self.setLoading(false);
        })
      );
      //set scale
      this.setScaleConfig(this.ganttView);
      this.setzoomlevelheightconfig(this.ganttZoom);
      let subtractDays = 0;
      if (this.ganttDay == "work-days") {
        gantt.ignore_time = function(date) {
          if (date.getDay() == 0 || date.getDay() == 6) {
            return true;
          }

          return false;
        };
        subtractDays = 15;
      } else if (this.ganttDay == "full-week") {
        gantt.ignore_time = function(date) {
          return false;
        };
        subtractDays = 11;
      }

      if (this.ganttView == "month") {
        subtractDays = 40;
      } else if (this.ganttView == "year") {
        subtractDays = 98;
      }

      gantt.init(this.$refs.gantt);
      // gantt.ext.tooltips.detach("["+gantt.config.task_attribute+"]:not(.gantt_task_row)")

      // gantt.ext.tooltips.tooltipFor({
      //   selector: ".gantt_task_row",
      //   html: function(event, domElement){
      //     return "sagar"
      //   }
      // });
      gantt.ext.tooltips.tooltipFor({
        selector: ".gantt_task_content",
        html: event => {
          if (gantt.config.touch && !gantt.config.touch_tooltip) {
            return;
          }

          const targetTaskId = gantt.locate(event);
          if (gantt.isTaskExists(targetTaskId)) {
            const task = gantt.getTask(targetTaskId);
            if (task.module.toUpperCase() == "TASK") {
              return (
                (task.last_comment && task.last_comment.description) ||
                "Last comment not found"
              );
            } else {
              if (task.tasks_count > 1) return `${task.tasks_count} Bracket(s)`;
              else return `${task.tasks_count} Bracket`;
            }
          }
          return null;
        },
        global: true
      });

      gantt.ext.tooltips.tooltipFor({
        selector: ".avatar-assigned-to",
        html: event => {
          if (gantt.config.touch && !gantt.config.touch_tooltip) {
            return;
          }

          const targetTaskId = gantt.locate(event);
          if (gantt.isTaskExists(targetTaskId)) {
            const task = gantt.getTask(targetTaskId);
            return `To: ${task.assignedTo.user.first_name} ${task.assignedTo.user.last_name}`;
          }
          return null;
        },
        global: true
      });

      gantt.ext.tooltips.tooltipFor({
        selector: ".avatar-assigned-by",
        html: event => {
          if (gantt.config.touch && !gantt.config.touch_tooltip) {
            return;
          }

          const targetTaskId = gantt.locate(event);
          if (gantt.isTaskExists(targetTaskId)) {
            const task = gantt.getTask(targetTaskId);
            return `By: ${task.assigned_by_client.user.first_name} ${task.assigned_by_client.user.last_name}`;
          }
          return null;
        },
        global: true
      });

      gantt.clearAll();
      gantt.parse(this.tasks);

      var scrollX = gantt.posFromDate(
        moment()
          .subtract(subtractDays, "d")
          .toDate()
      );
      gantt.scrollTo(scrollX, 0);
      self.setLoading(false);
    },

    initNormalGantt() {
      console.log("Normal gantt+");
      this.commentMode = this.ganttComment;

      gantt.config.show_errors = false;
      gantt.config.show_grid = false;

      gantt.config.details_on_dblclick = false; // double click false to remove lightbox
      gantt.config.drag_links = false;
      gantt.config.grid_resize = true;
      gantt.config.drag_progress = false;
      gantt.config.multiselect = true;
      gantt.config.drag_multiple = true;
      gantt.config.task_height = 26;
      gantt.config.scale_height = 55;
      // gantt.config.grid_width = 1;
      gantt.config.row_height = 36;
      // gantt.config.min_grid_column_width = false;
      // gantt.config.keep_grid_width = false;
      gantt.config.scale_unit = "month";
      gantt.config.date_scale = "%F %Y";
      // gantt.scrollTo(20 , null);
      // gantt.config.grid_resize = false;
      // gantt.config.show_grid = false;
      gantt.config.start_date = moment()
        .subtract(12, "months")
        .toDate();
      gantt.config.end_date = moment()
        .add(12, "months")
        .toDate();

      //Highlighting Days on weekend
      var daysStyle = function(date) {
        var dateToStr = gantt.date.date_to_str("%D");
        if (dateToStr(date) == "Sun" || dateToStr(date) == "Sat")
          return "weekend";
      };

      var win_width = $(window).width();

      var new_width = win_width - 25 - 8;
      var new_width_factor = new_width / 7;
      if (win_width < 768) {
        gantt.config.min_column_width = new_width_factor;
      } else {
        gantt.config.min_column_width = 25;
      }
      gantt.config.subscales = [
        {
          unit: "day",
          step: 1,
          // date: dayScaleTemplate
          date: "%d",
          css: daysStyle
        }
      ];

      //add text
      // let comment = "";
      // if (this.commentMode == "task-title") {
      //   comment = function(start, end, task) {
      //     //   console.log(task.name)
      //     return task.name != null ? task.name : null;
      //   };
      // } else if (this.commentMode == "last-comment") {
      //   comment = function(start, end, task) {
      //     return task.last_comment["comment"]
      //       ? task.last_comment["comment"] && task.last_comment["comment"].substring(0, 140)
      //       : 'This task has no comments';
      //   };
      // } else {
      //   comment = function(start, end, task) {
      //     return task.name != null ? task.name : null;
      //   };
      // }

      gantt.templates.task_text = function(start, end, task) {
        return null;
      };

      //alert(gantt.config.task_attribute)

      // add right side text
      let self = this;
      gantt.templates.rightside_text = (start, end, task) => {
        return `<a style="cursor:pointer"  class="ml-2 mr-2 taskLink text-muted" data-transition="slideleft" data-value=${task.asset_id}>
          ${task.name}
          </a>`;
      };

      gantt.templates.leftside_text = (start, end, task) => {
        var task_return = "";
        let avatar = "";
        let bg_colors = [
          "bg-success",
          "bg-info",
          "bg-default",
          "bg-darker",
          "bg-danger"
        ];
        let bg = "bg-success";
        if (task.assigned_by_client) {
          if (
            task.assigned_by_client.user &&
            task.assigned_by_client.user.profile_pic != null
          ) {
            avatar =
              '<img src="' +
              task.assigned_by_client.user.profile_pic.file_url +
              '" class="rounded-circle">';
          } else {
            let ch = task.assigned_by_client.user.first_name
              .substring(0, 1)
              .toUpperCase();
            bg =
              bg_colors[
                (ch.charCodeAt(0) +
                  task.assigned_by_client.user.first_name.length) %
                  5
              ];
            avatar =
              task.assigned_by_client.user.first_name
                .substring(0, 1)
                .toUpperCase() +
              (
                (task.assigned_by_client.user.last_name &&
                  task.assigned_by_client.user.last_name.substring(0, 1)) ||
                ""
              ).toUpperCase();
          }

          task.which_task = task.which_task || "left";

          task_return = `<div data-toggle="tooltip" data-trigger="hover" v-tooltip.top-center="${task.assigned_by_client.user.first_name} ${task.assigned_by_client.user.last_name}" class="d-flex w-auto align-items-center h-100 justify-content-end">
              <a href="#" data-user="${task.assigned_by_client.user.id}" class="avatar avatar-name avatar-sm-one avatar-assigned-by   tesss22ee text-white rounded-circle ${bg}" data-target="offcanvasFrom" data-offcanvasfrom="offcanvas" data-user="${task.assigned_by_client.user.id}" data-role-id="${task.assigned_by_client.asset_role.id}" data-role-name="${task.assigned_by_client.asset_role.name}">
                ${avatar}
              </a>
            </div>`;
          //task_return += '<span class="mr-1"><i class="fas fa-arrow-'+task.which_task+'"></i></span>';
        } else {
          task_return = `<div data-toggle="tooltip" data-trigger="hover" title="No User" class="d-flex w-auto align-items-center jhkh">
            <a href="#" class="avatar avatar-name avatar-sm ${bg} text-xl text-white rounded-circle" data-target="offcanvasFrom" data-offcanvasfrom="offcanvas">NU</a>
            </div>`;
          //task_return += '<span class="mr-1"><i class="fas fa-arrow-'+task.which_task+'"></i></span>';
        }

        if (self.showAssignedTo) {
          if (task.assigned_to_client) {
            task.assigned_to_client.map(r => {
              if (r.user.profile_pic != null) {
                avatar =
                  '<img src="' +
                  r.user.profile_pic.file_url +
                  '" class="rounded-circle">';
              } else {
                let chh = r.user.first_name.substring(0, 1).toUpperCase();

                bg =
                  bg_colors[(chh.charCodeAt(0) + r.user.first_name.length) % 5];
                avatar =
                  r.user.first_name.substring(0, 1).toUpperCase() +
                  (
                    (r.user.last_name && r.user.last_name.substring(0, 1)) ||
                    ""
                  ).toUpperCase();
              }

              task_return += `<div data-toggle="tooltip" data-trigger="hover" title="${r.user.first_name} ${r.user.last_name}" class="d-flex mr-1">
                  <a href="#" class="avatar avatar-name avatar-sm avatar-assigned-to ${bg} text-md text-white rounded-circle" data-target="offcanvasFrom" data-offcanvasfrom="offcanvas" data-user="${r.user.id}" data-role-id="${r.asset_role.id}" data-role-name="${r.asset_role.name}">
                    ${avatar}
                  </a>
                </div>`;
              // task_return += '<span class="mr-1"><i class="fas fa-arrow-right"></i></span>';
            });
          }
        }

        // task_return += `<a style="cursor:pointer"  class="ml-1 mr-2 taskLink" data-transition="slideleft" data-value=${task.asset_id}>
        //   ${task.name}
        //   </a>`;

        if (self.showBilling && task.total_seconds && false) {
          //billing disabled completely for now
          //console.log(task)
          let quotedHours = task.quoted_hours
            ? task.quoted_hours
            : task.quotedHours
            ? task.quotedHours
            : 0;
          let workedHours = task.total_seconds ? task.total_seconds : 0;
          workedHours = (workedHours / 3250).toFixed(2);
          let perHourRate = task.hourly_cost ? task.hourly_cost : 0;
          let totalCost = parseInt(workedHours) * perHourRate;
          if (totalCost >= 1000) {
            totalCost = (totalCost / 1000).toFixed(1) + "k";
          }

          task_return +=
            '<div class= "progress-label"> <div class="btn-group btn-group--totalhours" role="group" aria-label="Basic example"><button type="button" class="btn btn-info"><span data-toggle="tooltip" data-placement="left">' +
            workedHours +
            '</span></button><button type="button" class="btn btn-default "><span data-toggle="tooltip" data-placement="right" title="Total hours" data-target="offcanvasTimer" data-offcanvasfrom="offcanvas">' +
            quotedHours +
            '</span> <span class="badge badge-secondary  ml-1" data-toggle="tooltip" data-placement="right" title="' +
            quotedHours +
            " hours (" +
            self.currency.symbol +
            "" +
            perHourRate +
            ") per hour = " +
            self.currency.symbol +
            totalCost +
            '" data-target="offcanvasTimer" data-offcanvasfrom="offcanvas">' +
            self.currency.symbol +
            totalCost +
            "</span></button></div></div>";
        }

        return task_return;
      };

      var today_date = new Date();

      var lastday = function(y, m) {
        // console.log(date.getFullYear());
        return new Date(y, m + 1, 0).getDate();
      };

      gantt.templates.timeline_cell_class = function(item, date) {
        // console.log(today_date.getDate() +'<'+ date.getDate())
        var return_class;
        if (
          date.getDate() == today_date.getDate() &&
          date.getMonth() == today_date.getMonth() &&
          date.getFullYear() == today_date.getFullYear()
        ) {
          return_class = "today";
        }
        if (date.getDay() == 0 || date.getDay() == 6) {
          return_class += " weekend whichClass";
        }
        if (date.getDate() == lastday(date.getFullYear(), date.getMonth())) {
          // console.log('asdas');
          return_class += " lastDay";
        }

        return return_class;
      };

      if (self.enableResize == true) {
        gantt.config.drag_resize = false;
      }

      gantt.templates.tooltip_text = function(start, end, task) {
        //console.log(task, self.commentMode)

        if (task.module.toUpperCase() == "TASK") {
          // let txt = `
          //     <b>Task:</b> ${task.name}<br/>
          //     <b>Assigned By:</b> ${(task.assignedBy &&
          //       task.assignedBy.user.first_name) ||
          //       ""} ${(task.assignedBy && task.assignedBy.user.last_name) ||
          //   ""}<br/>
          //     <b>Assigned To:</b> ${(task.assignedTo &&
          //       task.assignedTo.user.first_name) ||
          //       ""} ${(task.assignedTo && task.assignedTo.user.last_name) ||
          //   ""}<br/>`;
          let txt = `
              <b>By:</b> ${(task.assignedBy &&
                task.assignedBy.user.first_name) ||
                ""} ${(task.assignedBy && task.assignedBy.user.last_name) ||
            ""}<br/>
              <b>To:</b> ${(task.assignedTo &&
                task.assignedTo.user.first_name) ||
                ""} ${(task.assignedTo && task.assignedTo.user.last_name) ||
            ""}<br/>`;

          // if (self.commentMode == "last-comment") {
          //   txt += `
          //         <b>Last Comment:</b> ${(task.last_comment &&
          //           task.last_comment.description) ||
          //           ""}<br/>
          //       `;
          // }
          return txt;
        } else {
          // let t = `
          //     <b>Task:</b> ${task.name}<br/>
          //     <b>Owner:</b> ${task && task.user_owner.user.first_name} ${task &&
          //   task.user_owner.user.last_name}<br/>
          //     `;

          //  console.log(task.user_owner, 'taskkk')
          let t = `<b>Owner:</b> ${task &&
            task.user_owner != null &&
            task.user_owner.user.first_name} ${task &&
            task.user_owner != null &&
            task.user_owner.user.last_name}<br/>`;

          // if (self.commentMode == "last-comment") {
          //   //enable by default for
          //   t += `
          //         <b>Last Comment:</b> ${(task.last_comment &&
          //           task.last_comment.description) ||
          //           ""}<br/>
          //       `;
          // }
          return t;
        }
      };
    },

    setScaleConfig(value) {
      switch (value) {
        case "mins_5":
          gantt.config.scale_unit = "day";
          gantt.config.step = 1;
          gantt.config.date_scale = "%D, %F %d, %Y";
          gantt.config.date_grid = "%H:%i";
          gantt.config.duration_unit = "minute";
          // gantt.config.grid_resize = true;
          gantt.config.subscales = [
            {
              unit: "hour",
              step: 1,
              // date: dayScaleTemplate
              date: "%g %a",
              css: daysStyle
            },
            { unit: "minute", step: 5, date: "%i", css: this.borderStyle1 }
          ];
          if (win_width < 768) {
            gantt.config.min_column_width = new_width_factor;
          } else {
            gantt.config.min_column_width = 18;
          }
          gantt.templates.timeline_cell_class = function(item, date) {
            var return_class,
              hour = date.getHours(),
              minute = date.getMinutes();
            // var dateToStr = gantt.date.date_to_str("%i");
            // if (dateToStr(date)) return "secondBlur borderRight";
            if (minute == 55) {
              // return "borderRight";
              return_class = "borderRight";
            }
            if (hour % 2 != 0) {
              return_class += " alternative";
            } else {
              return_class += "";
            }

            return return_class;
          };
          // $('body').removeClass('MonthView');
          // $('body').removeClass('YearView');
          gantt.templates.date_scale = null;
          break;
        case "mins_10":
          gantt.config.scale_unit = "day";
          gantt.config.step = 1;
          gantt.config.date_scale = "%D, %F %d, %Y";
          gantt.config.date_grid = "%H:%i";
          gantt.config.duration_unit = "minute";
          // gantt.config.grid_resize = true;
          gantt.config.subscales = [
            {
              unit: "hour",
              step: 1,
              // date: dayScaleTemplate
              date: "%g %a",
              css: daysStyle
            },
            { unit: "minute", step: 10, date: "%i", css: this.borderStyle2 }
          ];
          gantt.templates.timeline_cell_class = function(item, date) {
            var return_class,
              hour = date.getHours(),
              minute = date.getMinutes();
            // var dateToStr = gantt.date.date_to_str("%i");
            // if (dateToStr(date)) return "secondBlur borderRight";
            if (minute == 50) {
              // return "borderRight";
              return_class = "borderRight";
            }
            if (hour % 2 != 0) {
              return_class += " alternative";
            } else {
              return_class += "";
            }

            return return_class;
          };
          if (win_width < 768) {
            gantt.config.min_column_width = new_width_factor + 3;
          } else {
            gantt.config.min_column_width = 25;
          }
          // $('body').removeClass('MonthView');
          // $('body').removeClass('YearView');
          gantt.templates.date_scale = null;
          break;
        case "mins_15":
          gantt.config.scale_unit = "day";
          gantt.config.step = 1;
          gantt.config.date_scale = "%D, %F %d, %Y";
          gantt.config.date_grid = "%H:%i";
          gantt.config.duration_unit = "minute";
          // gantt.config.grid_resize = true;
          gantt.config.subscales = [
            {
              unit: "hour",
              step: 1,
              // date: dayScaleTemplate
              date: "%g %a",
              css: daysStyle
            },
            { unit: "minute", step: 15, date: "%i", css: this.borderStyle3 }
          ];
          gantt.templates.timeline_cell_class = function(item, date) {
            var return_class,
              hour = date.getHours(),
              minute = date.getMinutes();
            // var dateToStr = gantt.date.date_to_str("%i");
            // if (dateToStr(date)) return "secondBlur borderRight";
            if (minute == 45) {
              // return "borderRight";
              return_class = "borderRight";
            }
            if (hour % 2 != 0) {
              return_class += " alternative";
            } else {
              return_class += "";
            }

            return return_class;
          };
          if (win_width < 768) {
            gantt.config.min_column_width = new_width_factor + 5;
          } else {
            gantt.config.min_column_width = 30;
          }
          // $('body').removeClass('MonthView');
          // $('body').removeClass('YearView');
          gantt.templates.date_scale = null;

          break;
        case "day": // day
          // alert('day');

          gantt.config.scale_unit = "month";
          gantt.config.step = 1;
          gantt.config.date_scale = "%F, %Y";
          var weekScaleTemplate = function(date) {
            var dateToStr = gantt.date.date_to_str("%d %M");
            var endDate = gantt.date.add(
              gantt.date.add(date, 1, "week"),
              -1,
              "day"
            );
            return dateToStr(date) + " - " + dateToStr(endDate);
          };

          var daysStyle = function(date) {
            // you can use gantt.isWorkTime(date)
            // when gantt.config.work_time config is enabled
            // In this sample it's not so we just check week days

            if (date.getDay() === 0 || date.getDay() === 6) {
              return "weekend";
            }
            return "day";
          };
          gantt.config.subscales = [
            { unit: "week", step: 1, format: weekScaleTemplate },
            { unit: "day", step: 1, format: "%d", css: daysStyle }
          ];

          gantt.config.min_column_width = 25;
          var win_width = $(window).width();

          var new_width = win_width - 25 - 8;
          var new_width_factor = new_width / 7;
          if (win_width < 768) {
            gantt.config.min_column_width = new_width_factor;
          } else {
            gantt.config.min_column_width = 25;
          }
          $("body").removeClass("MonthView");
          $("body").removeClass("YearView");
          gantt.templates.date_scale = null;

          break;
        case "week": // week
          var weekScaleTemplate = function(date) {
            var dateToStr = gantt.date.date_to_str("%j %M");
            var endDate = gantt.date.add(
              gantt.date.add(date, 1, "week"),
              -1,
              "day"
            );
            return dateToStr(date) + " - " + dateToStr(endDate);
          };

          gantt.config.scale_unit = "week";
          gantt.config.step = 1;
          gantt.templates.date_scale = weekScaleTemplate;
          gantt.config.subscales = [
            {
              unit: "day",
              step: 1,
              date: "%D"
            }
          ];

          var win_width = $(window).width();
          // var gantt_grid = $('.gantt_grid').width();
          var new_width = win_width - 8;
          var new_width_factor = new_width / 7;

          // gantt.config.min_column_width = new_width_factor;
          if (win_width < 768) {
            gantt.config.min_column_width = new_width_factor;
          } else {
            gantt.config.min_column_width = 25;
          }

          // gantt.config.scale_height = 62;

          // $('.c-gantt--viewbutton span').text('Weeks');
          $("body").removeClass("MonthView");
          $("body").removeClass("YearView");

          break;
        case "month": // month
          // alert('month');
          var today_date = new Date();
          gantt.config.scale_unit = "month";
          gantt.config.step = 1;
          gantt.config.date_scale = "%F %Y";
          var weekScaleTemplate = function(date) {
            var dateToStr = gantt.date.date_to_str("%d %M");
            var endDate = gantt.date.add(
              gantt.date.add(date, 1, "week"),
              -3,
              "day"
            );
            return dateToStr(date) + " - " + dateToStr(endDate);
          };
          var daysStyle = function(date) {
            var dateToStr = gantt.date.date_to_str("%D");
            if (dateToStr(date) == "Sun" || dateToStr(date) == "Sat")
              return "weekend";

            if (
              date.getDate() == today_date.getDate() &&
              date.getMonth() == today_date.getMonth() &&
              date.getFullYear() == today_date.getFullYear()
            ) {
              return "today";
            }

            return "";
          };
          gantt.config.subscales = [
            {
              unit: "week",
              step: 1,
              template: weekScaleTemplate
            },
            { unit: "day", step: 1, date: "%D", css: daysStyle }
          ];
          gantt.templates.date_scale = null;
          var win_width = $(window).width();
          // var gantt_grid = $('.gantt_grid').width();
          var new_width = win_width;
          var new_width_factor = new_width / 20;
          // console.log(gantt_grid);
          console.log(new_width_factor);
          if (win_width < 768) {
            gantt.config.min_column_width = new_width_factor;
          } else {
            gantt.config.min_column_width = 20;
          }
          $("body").addClass("MonthView");
          $("body").removeClass("YearView");
          // gantt.config.min_column_width = new_width_factor;
          // gantt.config.scale_height = 62;

          // $('.c-gantt--viewbutton span').text('Months');
          break;
        case "year": //  year if needed
          gantt.config.scale_unit = "year";
          gantt.config.step = 1;
          gantt.config.date_scale = "%Y";
          gantt.config.min_column_width = 7;
          // gantt.config.template: monthScaleTemplate;
          // gantt.config.scale_height = 90;
          var daysStyle = function(date) {
            var dateToStr = gantt.date.date_to_str("%D");
            if (dateToStr(date) == "Sun" || dateToStr(date) == "Sat")
              return "weekend";
            return "";
          };
          var monthScaleTemplate = function(date) {
            var dateToStr = gantt.date.date_to_str("%M");
            var endDate = gantt.date.add(date, 2, "month");
            return dateToStr(date) + " - " + dateToStr(endDate);
          };

          gantt.config.subscales = [
            // {unit: "month", step: 3, template: monthScaleTemplate},
            {
              unit: "month",
              step: 1,
              date: "%F"
            },
            { unit: "day", step: 1, date: "%D", css: daysStyle }
          ];
          gantt.templates.date_scale = null;

          $("body").removeClass("MonthView");
          $("body").addClass("YearView");

          break;
      }
    },

    resetGantt() {
      gantt.clearAll();
      while (events.length) {
        const ev = events.pop();
        //console.log(ev, "Detachhed")
        gantt.detachEvent(ev);
      }
    },

    setzoomlevelheightconfig(value) {
      switch (value) {
        case "few":
          // alert('asdsad');
          $("body").addClass("zoomlevel-1");
          $("body").removeClass("zoomlevel-2");
          $("body").removeClass("zoomlevel-3");
          console.log("setzoomlevelheightconfig 1");
          gantt.config.task_height = 26;
          gantt.config.scale_height = 55;
          gantt.config.grid_width = 40;
          gantt.config.row_height = 36;
          // gantt.config.row_height = 56;

          console.log(gantt.config.grid_width);
          gantt.config.show_grid = false;

          break;

        case "many":
          $("body").addClass("zoomlevel-2");
          $("body").removeClass("zoomlevel-3");
          $("body").removeClass("zoomlevel-1");
          gantt.config.task_height = 28;
          gantt.config.scale_height = 55;
          gantt.config.row_height = 38;
          gantt.config.grid_width = 40;
          console.log(gantt.config.grid_width);
          gantt.config.show_grid = false;

          break;

        // $('gantt_here .gantt_grid').hide();
      }
    }
  },

  computed: {
    ...mapState(["ganttRender"]),

    ...mapState("user", ["profile"])
  },
  created() {
    //this.setLoading(true)
  },
  mounted() {
    console.log("gantt mounted", this.ganttView.includes("mins"));
    this.initGantt();

    let self = this;
    //this.setLoading(false)

    // $("body").on("click", ".taskLink", function(event) {
    //   console.log("sssssss", $(this).attr("data-value"));
    //   let id = $(this).attr("data-value");
    //   self.onTaskLinkClicked(id, event);
    // });
  },

  beforeDestroy() {
    this.resetGantt();
  }
};
</script>
